export default __webpack_public_path__ + "static/media/4.60908e35.png";